import { create } from "zustand";
import { collection, getDocs, query, where, onSnapshot, updateDoc, doc, limit } from "@firebase/firestore";
import { db } from "../lib/firebase";

const useAuthStore = create((set) => ({
  user: null,
  userDetails: null,
  allUserDetails: [],
  sidebarStatus: false,
  setSidebarStatus: (sidebarStatus) => set({sidebarStatus}),
  setUser: (user) => set({ user }),
  setUserDetails: async (uid) => {
    try {
      const q = query(collection(db, 'user_details'), where('uid', '==', uid));
      const querySnapshot = await getDocs(q);

      querySnapshot.forEach((doc) => {
        set({ userDetails: doc.data() });
      });
    } catch (error) {
      console.error("Error getting documents: ", error);
    }
  },
  fetchAllUserDetails: async () => {
    const userDetailsCollection = collection(db, 'user_details');

    const unsubscribe = onSnapshot(userDetailsCollection, snapshot => {
      const userDetailsArray = [];
      snapshot.forEach((doc) => {
        userDetailsArray.push({
          id: doc.id,
          ...doc.data()
        });
      });

      set({ allUserDetails: userDetailsArray });
    });

    return unsubscribe;
  },
  updateLastActiveTime: async (uid) => {
    try {
      const userDetailsCollection = collection(db, 'user_details');
      const q = query(userDetailsCollection, where('uid', '==', uid), limit(1));
  
      const querySnapshot = await getDocs(q);
  
      if (!querySnapshot.empty) {
        const documentSnapshot = querySnapshot.docs[0];
        const userDocRef = doc(db, 'user_details', documentSnapshot.id);
  
        const updateData = {
          lastActive: new Date()
        };
  
        await updateDoc(userDocRef, updateData);
      } else {
        console.log('No matching document found');
      }
    } catch (error) {
      console.error('Error updating user detail:', error);
    }
  }
}));

export default useAuthStore;
